import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=bc3118b0&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=bc3118b0&prod&scoped=true&lang=scss&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=bc3118b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3118b0",
  null
  
)

export default component.exports